export const orderDetailsResponse = {
  orderDetails: {
    cartAmount: 10000.0,
    orderId: '<uuid>',
    merchantName: 'Flipkart',
    merchantLogo: 'https://iccdn.in/img/merchant-logo.jpg',
    channel: 'ONLINE',
    txnRemainingTimeInSeconds: 533,
  },
  eligibilityDetails: {
    userStatus: 'REGISTERED',
    isEligible: true,
    isNTBAllowed: true,
    mobile: '9324546575',
    emiLenderDetailsList: [
      {
        lenderId: 1401,
        logo: 'https://iccdn.in/lenders/CASHe-Logo.png',
        logoIcon: 'https://iccdn.in/lenders/CASHe-icon.png',
        lenderName: 'CASHe',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',
        aivfDetails: {
          aivfType: 'PAN_CARD_NUMBERS',
        },

        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 16,
            monthlyInstallment: 3467,
            totalInterest: 401,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 3467,
            effectiveTotalInterest: 401,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001059,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10401,
            apr: 23.9,
          },
          {
            loanDuration: 6,
            interestRate: 15,
            monthlyInstallment: 1792,
            totalInterest: 752,
            effectiveInterestRate: 15,
            effectiveMonthlyInstallment: 1792,
            effectiveTotalInterest: 752,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001060,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10752,
            apr: 25.34,
          },
          {
            loanDuration: 9,
            interestRate: 14.66,
            monthlyInstallment: 1233,
            totalInterest: 1097,
            effectiveInterestRate: 14.66,
            effectiveMonthlyInstallment: 1233,
            effectiveTotalInterest: 1097,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001061,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11097,
            apr: 25.61,
          },
          {
            loanDuration: 12,
            interestRate: 14.5,
            monthlyInstallment: 954,
            totalInterest: 1448,
            effectiveInterestRate: 14.5,
            effectiveMonthlyInstallment: 954,
            effectiveTotalInterest: 1448,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001062,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11448,
            apr: 25.73,
          },
        ],
        emiNotes: [
          'A processing fee of 1.5% of the transaction value will be charged by CASHe in the first EMI.',
        ],
        authorizedRecoveryAgentDetails:
          'https://www.cashe.co.in/our-collection-agencies/',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
        kfsDisplayLenderName: 'Bhanix Finance & Investment Ltd',
      },
      {
        lenderId: 701,
        logo: 'https://iccdn.in/lenders/icici-main-logo-v3.svg',
        logoIcon: 'https://iccdn.in/lenders/icici-icon-logo-v4.svg',
        lenderName: 'ICICI Bank',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',
        aivfDetails: {
          aivfType: 'PAN_CARD',
        },

        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 16,
            monthlyInstallment: 3423,
            totalInterest: 269,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 3423,
            effectiveTotalInterest: 269,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001054,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10269,
          },
          {
            loanDuration: 6,
            interestRate: 16,
            monthlyInstallment: 1667,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 1667,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 9550,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 450,
            creditSchemeVariantId: 2001049,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10000,
          },
          {
            loanDuration: 9,
            interestRate: 16,
            monthlyInstallment: 1112,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 1112,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 9365,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 635,
            creditSchemeVariantId: 2001050,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10000,
          },
          {
            loanDuration: 12,
            interestRate: 18,
            monthlyInstallment: 984,
            totalInterest: 1808,
            effectiveInterestRate: 18,
            effectiveMonthlyInstallment: 984,
            effectiveTotalInterest: 1808,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001051,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11808,
          },
          {
            loanDuration: 18,
            interestRate: 16,
            monthlyInstallment: 689,
            totalInterest: 2402,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 689,
            effectiveTotalInterest: 2402,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001052,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 12402,
          },
          {
            loanDuration: 24,
            interestRate: 16,
            monthlyInstallment: 550,
            totalInterest: 3200,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 550,
            effectiveTotalInterest: 3200,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001053,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 13200,
          },
        ],
        emiNotes: [],
        lenderTncUrl:
          'https://www.icicibank.com/managed-assets/docs/terms-condition/primary-tnc-for-cardless-emi.pdf',
        emiDiscountType: 'NO_COST_EMI',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 201,
        logo: 'https://iccdn.in/lenders/IDFC-First-Bank-Logo-150.jpg',
        logoIcon: 'https://iccdn.in/img/idfc-first-icon-v1.png',
        lenderName: 'IDFC First Bank',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',
        aivfDetails: {
          aivfType: 'PAN_CARD_NUMBERS',
        },

        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 24,
            monthlyInstallment: 3468,
            totalInterest: 404,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 3468,
            effectiveTotalInterest: 404,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1000001,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10404,
            apr: 24,
          },
          {
            loanDuration: 6,
            interestRate: 24,
            monthlyInstallment: 1786,
            totalInterest: 716,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1786,
            effectiveTotalInterest: 716,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1000002,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10716,
            apr: 24,
          },
          {
            loanDuration: 9,
            interestRate: 24,
            monthlyInstallment: 1226,
            totalInterest: 1034,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1226,
            effectiveTotalInterest: 1034,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1000003,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11034,
            apr: 24,
          },
          {
            loanDuration: 12,
            interestRate: 24,
            monthlyInstallment: 946,
            totalInterest: 1352,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 946,
            effectiveTotalInterest: 1352,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1000004,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11352,
            apr: 24,
          },
        ],
        emiNotes: [],
        lenderTncUrl: 'https://capitalfirst.com/instacred-terms-conditions',
        processingFee: 0,
        otherCharges: 0,
        penalCharges: {
          'Bounce Charges': 'Rs. 400 + GST ',
          'Late Payment Penalty':
            '2% of outstanding EMI amount + GST (Or Rs. 300 + GST, whichever is higher)',
          'Foreclosure Charge': '5% of Principal outstanding amount + GST',
        },
        coolingOffPeriod: 'Upto date of first EMI',
        repaymentFrequency: 'Monthly',
        lenderNodalGrievanceOfficerDetails: {
          Name: 'Ms. T Arora',
          Designation: 'PNO',
          Address:
            'IDFC FIRST Bank Ltd. Building No.2, Raheja Mindspace, MIDC Industrial Area, Shiravane, Juinagar, Nerul, Navi Mumbai 400706, Maharashtra, India',
          Contact: '1860 500 9900 / 1800 209 9971',
        },
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
        kfsDisplayLenderName: 'IDFC First Bank',
      },
      {
        lenderId: 401,
        logo: 'https://iccdn.in/lenders/kotak-bank-logo-list-40px.svg',
        logoIcon: 'https://iccdn.in/img/kotak-icon-v1.png',
        lenderName: 'Kotak Mahindra Bank',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'PAN_CARD_NUMBERS',
        },
        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 17,
            monthlyInstallment: 3475,
            totalInterest: 425,
            effectiveInterestRate: 17,
            effectiveMonthlyInstallment: 3475,
            effectiveTotalInterest: 425,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001462,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10425,
          },
          {
            loanDuration: 6,
            interestRate: 17,
            monthlyInstallment: 1809,
            totalInterest: 854,
            effectiveInterestRate: 17,
            effectiveMonthlyInstallment: 1809,
            effectiveTotalInterest: 854,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001463,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10854,
          },
          {
            loanDuration: 9,
            interestRate: 17,
            monthlyInstallment: 1253,
            totalInterest: 1277,
            effectiveInterestRate: 17,
            effectiveMonthlyInstallment: 1253,
            effectiveTotalInterest: 1277,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001464,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11277,
          },
          {
            loanDuration: 12,
            interestRate: 17,
            monthlyInstallment: 975,
            totalInterest: 1700,
            effectiveInterestRate: 17,
            effectiveMonthlyInstallment: 975,
            effectiveTotalInterest: 1700,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001465,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11700,
          },
        ],
        emiNotes: [
          'INR 199 processing fee will be charged by Kotak Mahindra Bank on all EMI plans',
        ],
        lenderTncUrl:
          'https://www.kotak.com/en/customer-service/important-customer-information/mitc-consumer-bank.html',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: true,
      },
      {
        lenderId: 601,
        logo: 'https://iccdn.in/lenders/Home-Credit-Logo.svg',
        logoIcon: 'https://iccdn.in/lenders/home-credit-icon-v1.svg',
        lenderName: 'Home Credit',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'LAST_DIGITS_OF_DEBIT_CARD',
        },
        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 24,
            monthlyInstallment: 3474,
            totalInterest: 422,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 3474,
            effectiveTotalInterest: 422,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001015,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10404,
          },
          {
            loanDuration: 6,
            interestRate: 24,
            monthlyInstallment: 1788,
            totalInterest: 728,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1788,
            effectiveTotalInterest: 728,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001016,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10716,
          },
          {
            loanDuration: 9,
            interestRate: 24,
            monthlyInstallment: 1228,
            totalInterest: 1052,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1228,
            effectiveTotalInterest: 1052,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001017,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11034,
          },
          {
            loanDuration: 12,
            interestRate: 24,
            monthlyInstallment: 948,
            totalInterest: 1376,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 948,
            effectiveTotalInterest: 1376,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001018,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11352,
          },
        ],
        emiNotes: [],
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 501,
        logo: 'https://iccdn.in/lenders/hdfc-transparent-logo.png',
        logoIcon: 'https://iccdn.in/img/hdfc-logo-icon-v2.png',
        lenderName: 'HDFC Bank',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'PAN_CARD_NUMBERS',
        },
        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 16,
            monthlyInstallment: 3334,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 3334,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 9739.14,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 260.86,
            creditSchemeVariantId: 2001046,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10000,
          },
          {
            loanDuration: 6,
            interestRate: 16,
            monthlyInstallment: 1746,
            totalInterest: 476,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 1746,
            effectiveTotalInterest: 476,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001044,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10476,
          },
          {
            loanDuration: 9,
            interestRate: 16,
            monthlyInstallment: 1112,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 1112,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 9364.67,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 635.33,
            creditSchemeVariantId: 2001047,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10000,
          },
          {
            loanDuration: 12,
            interestRate: 16,
            monthlyInstallment: 834,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 834,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 9184.67,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 815.33,
            creditSchemeVariantId: 2001048,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10000,
          },
          {
            loanDuration: 18,
            interestRate: 16,
            monthlyInstallment: 629,
            totalInterest: 1322,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 629,
            effectiveTotalInterest: 1322,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001045,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11322,
          },
        ],
        emiNotes: [
          'A convenience fee of Rs. 199 + GST will be applied by HDFC Bank per transaction.',
        ],
        lenderTncUrl:
          'https://www.hdfcbank.com/personal/borrow/popular-loans/easy-emi/easyemi-on-consumer-durables/emi-on-debit-card',
        emiDiscountType: 'NO_COST_EMI',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 102,
        logo: 'https://iccdn.in/lenders/federal_logo.png',
        logoIcon:
          'https://lh3.googleusercontent.com/QifW_OELeiL7Cs5uETJmA8aGXS0Pd9ZrqRaq7Olyl-SbKfOBSXDK7zpE_eCyL99W4AY=s180-rw',
        lenderName: 'Federal Bank',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'LAST_DIGITS_OF_DEBIT_CARD',
        },
        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 15,
            monthlyInstallment: 3334,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 3334,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 9755.11,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 244.89,
            creditSchemeVariantId: 2001055,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
          },
          {
            loanDuration: 6,
            interestRate: 15,
            monthlyInstallment: 1741,
            totalInterest: 442.03,
            effectiveInterestRate: 15,
            effectiveMonthlyInstallment: 1741,
            effectiveTotalInterest: 442.03,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001056,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
          },
          {
            loanDuration: 9,
            interestRate: 15,
            monthlyInstallment: 1182,
            totalInterest: 635.35,
            effectiveInterestRate: 15,
            effectiveMonthlyInstallment: 1182,
            effectiveTotalInterest: 635.35,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001057,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
          },
          {
            loanDuration: 12,
            interestRate: 15,
            monthlyInstallment: 903,
            totalInterest: 831,
            effectiveInterestRate: 15,
            effectiveMonthlyInstallment: 903,
            effectiveTotalInterest: 831,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001058,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
          },
        ],
        emiNotes: [],
        lenderTncUrl: 'https://www.federalbank.co.in/instacred',
        emiDiscountType: 'NO_COST_EMI',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 901,
        logo: 'https://iccdn.in/lenders/bob-logo-sqr.svg',
        logoIcon: 'https://iccdn.in/lenders/bob-sqr-logo.svg',
        lenderName: 'Bank Of Baroda',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'LAST_DIGITS_OF_DEBIT_CARD',
        },
        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 24,
            monthlyInstallment: 3468,
            totalInterest: 404,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 3468,
            effectiveTotalInterest: 404,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001024,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10404,
          },
          {
            loanDuration: 6,
            interestRate: 24,
            monthlyInstallment: 1785,
            totalInterest: 710,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1785,
            effectiveTotalInterest: 710,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001025,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10710,
          },
          {
            loanDuration: 9,
            interestRate: 16,
            monthlyInstallment: 1187,
            totalInterest: 683,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 1187,
            effectiveTotalInterest: 683,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001286,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10683,
          },
          {
            loanDuration: 9,
            interestRate: 24,
            monthlyInstallment: 1225,
            totalInterest: 1025,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1225,
            effectiveTotalInterest: 1025,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001026,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11025,
          },
          {
            loanDuration: 12,
            interestRate: 24,
            monthlyInstallment: 946,
            totalInterest: 1352,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 946,
            effectiveTotalInterest: 1352,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001027,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11352,
          },
          {
            loanDuration: 12,
            interestRate: 16,
            monthlyInstallment: 907,
            totalInterest: 884,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 907,
            effectiveTotalInterest: 884,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001287,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10884,
          },
          {
            loanDuration: 15,
            interestRate: 16,
            monthlyInstallment: 740,
            totalInterest: 1100,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 740,
            effectiveTotalInterest: 1100,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001288,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11100,
          },
          {
            loanDuration: 18,
            interestRate: 16,
            monthlyInstallment: 629,
            totalInterest: 1322,
            effectiveInterestRate: 16,
            effectiveMonthlyInstallment: 629,
            effectiveTotalInterest: 1322,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001289,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11322,
          },
        ],
        emiNotes: [],
        lenderTncUrl: '',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 1201,
        logo: 'https://www.hdbfs.com/sites/default/files/images/logo_2021.svg',
        logoIcon: 'https://iccdn.in/img/hdfc-logo-icon-v2.png',
        lenderName: 'HDB FS',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',
        aivfDetails: {},

        aivfDetails: {
          aivfType: 'PAN_CARD',
        },
        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 24,
            monthlyInstallment: 3468,
            totalInterest: 404,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 3468,
            effectiveTotalInterest: 404,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001036,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10404,
          },
          {
            loanDuration: 3,
            interestRate: 22,
            monthlyInstallment: 3457,
            totalInterest: 371,
            effectiveInterestRate: 22,
            effectiveMonthlyInstallment: 3457,
            effectiveTotalInterest: 371,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001418,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10371,
          },
          {
            loanDuration: 6,
            interestRate: 22,
            monthlyInstallment: 1776,
            totalInterest: 656,
            effectiveInterestRate: 22,
            effectiveMonthlyInstallment: 1776,
            effectiveTotalInterest: 656,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001419,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10656,
          },
          {
            loanDuration: 6,
            interestRate: 24,
            monthlyInstallment: 1786,
            totalInterest: 716,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1786,
            effectiveTotalInterest: 716,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001037,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10716,
          },
          {
            loanDuration: 9,
            interestRate: 24,
            monthlyInstallment: 1226,
            totalInterest: 1034,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1226,
            effectiveTotalInterest: 1034,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001038,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11034,
          },
          {
            loanDuration: 9,
            interestRate: 22,
            monthlyInstallment: 1216,
            totalInterest: 944,
            effectiveInterestRate: 22,
            effectiveMonthlyInstallment: 1216,
            effectiveTotalInterest: 944,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001420,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10944,
          },
          {
            loanDuration: 12,
            interestRate: 24,
            monthlyInstallment: 946,
            totalInterest: 1352,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 946,
            effectiveTotalInterest: 1352,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001039,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11352,
          },
          {
            loanDuration: 12,
            interestRate: 22,
            monthlyInstallment: 936,
            totalInterest: 1232,
            effectiveInterestRate: 22,
            effectiveMonthlyInstallment: 936,
            effectiveTotalInterest: 1232,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001421,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11232,
          },
        ],
        emiNotes: [],
        lenderTncUrl: 'https://www.hdbfs.com/npa-classification-norms',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 1,
        logo: 'https://iccdn.in/img/InstaLend.png',
        logoIcon: 'https://iccdn.in/img/instalend-icon-v1.png',
        lenderName: 'Instalend',
        lenderType: 'EMI',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'NONE',
        },
        emiDetailsList: [
          {
            loanDuration: 3,
            interestRate: 24,
            monthlyInstallment: 3468,
            totalInterest: 404,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 3468,
            effectiveTotalInterest: 404,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2000006,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10404,
          },
          {
            loanDuration: 3,
            interestRate: 24,
            monthlyInstallment: 3468,
            totalInterest: 404,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 3468,
            effectiveTotalInterest: 404,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1000006,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10404,
          },
          {
            loanDuration: 6,
            interestRate: 24,
            monthlyInstallment: 1786,
            totalInterest: 716,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1786,
            effectiveTotalInterest: 716,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2000007,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10716,
          },
          {
            loanDuration: 6,
            interestRate: 24,
            monthlyInstallment: 1786,
            totalInterest: 716,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1786,
            effectiveTotalInterest: 716,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1000007,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 10716,
          },
          {
            loanDuration: 9,
            interestRate: 24,
            monthlyInstallment: 1226,
            totalInterest: 1034,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 1226,
            effectiveTotalInterest: 1034,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2000008,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11034,
          },
          {
            loanDuration: 12,
            interestRate: 24,
            monthlyInstallment: 946,
            totalInterest: 1352,
            effectiveInterestRate: 24,
            effectiveMonthlyInstallment: 946,
            effectiveTotalInterest: 1352,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2000009,
            isSubventionEnabled: false,
            tenureType: 'MONTHS',
            totalRepaymentAmount: 11352,
          },
        ],
        emiNotes: [],
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
    ],
    payLaterLenderDetailsList: [
      {
        lenderId: 402,
        logo: 'https://iccdn.in/lenders/kotak-consumer-v5.png',
        logoIcon: 'https://iccdn.in/img/kotak-icon-v1.png',
        lenderName: 'Pay Later by Kotak Mahindra Bank',
        lenderType: 'PAY_LATER',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'PAN_CARD_NUMBERS',
        },
        emiDetailsList: [
          {
            loanDuration: 15,
            interestRate: 0,
            monthlyInstallment: 0,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 0,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001030,
            isSubventionEnabled: false,
            tenureType: 'DAYS',
            emiSchedule: {
              '1672905135721': 10000,
            },
          },
          {
            loanDuration: 15,
            interestRate: 0,
            monthlyInstallment: 0,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 0,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001253,
            isSubventionEnabled: false,
            tenureType: 'DAYS',
            emiSchedule: {
              '1672905135721': 10000,
            },
          },
        ],
        emiDates: [1672905135721],
        emiNotes: [],
        lenderTncUrl:
          'https://www.kotak.com/en/customer-service/important-customer-information/mitc-consumer-bank.html',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 502,
        logo: 'https://iccdn.in/lenders/flexipay-40px-logo.png',
        logoIcon: 'https://iccdn.in/img/hdfc-logo-icon-v2.png',
        lenderName: 'FlexiPay By HDFC Bank',
        lenderType: 'PAY_LATER',
        creditLineStatus: 'PRE_APPROVED',

        aivfDetails: {
          aivfType: 'PAN_CARD_NUMBERS',
        },
        emiDetailsList: [
          {
            loanDuration: 15,
            interestRate: 14,
            monthlyInstallment: 117,
            totalInterest: 117,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 0,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 9883.33,
            totalDiscountAmount: 116.67,
            flexmoneyDiscountAmount: 116.67,
            creditSchemeVariantId: 2001010,
            isSubventionEnabled: true,
            tenureType: 'DAYS',
            emiSchedule: {
              '1672531200000': 10000,
            },
          },
          {
            loanDuration: 30,
            interestRate: 28,
            monthlyInstallment: 234,
            totalInterest: 234,
            effectiveInterestRate: 28,
            effectiveMonthlyInstallment: 234,
            effectiveTotalInterest: 234,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001011,
            isSubventionEnabled: false,
            tenureType: 'DAYS',
            emiSchedule: {
              '1673827200000': 10234,
            },
          },
          {
            loanDuration: 60,
            interestRate: 28,
            monthlyInstallment: 234,
            totalInterest: 468,
            effectiveInterestRate: 28,
            effectiveMonthlyInstallment: 234,
            effectiveTotalInterest: 468,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001012,
            isSubventionEnabled: false,
            tenureType: 'DAYS',
            emiSchedule: {
              '1676505600000': 10234,
              '1673827200000': 234,
            },
          },
          {
            loanDuration: 90,
            interestRate: 28,
            monthlyInstallment: 234,
            totalInterest: 702,
            effectiveInterestRate: 28,
            effectiveMonthlyInstallment: 234,
            effectiveTotalInterest: 702,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001013,
            isSubventionEnabled: false,
            tenureType: 'DAYS',
            emiSchedule: {
              '1678924800000': 10234,
              '1676505600000': 234,
              '1673827200000': 234,
            },
          },
        ],
        emiDates: [1672531200000, 1673827200000, 1676505600000, 1678924800000],
        emiNotes: [
          'Payment due will be auto debited from your HDFC Bank Account',
        ],
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
      {
        lenderId: 10002,
        logo: 'https://iccdn.in/lenders/sbi-logo-1.png',
        logoIcon: 'https://iccdn.in/img/sbi-icon.png',
        lenderName: 'SBI Paylater',
        lenderType: 'PAY_LATER',
        creditLineStatus: 'PRE_APPROVED',
        aivfDetails: {
          aivfType: 'PAN_CARD_NUMBERS',
        },
        emiDetailsList: [
          {
            loanDuration: 30,
            interestRate: 0,
            monthlyInstallment: 0,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 0,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 2001031,
            isSubventionEnabled: false,
            tenureType: 'DAYS',
            emiSchedule: {
              '1672905135729': 10000,
            },
          },
          {
            loanDuration: 30,
            interestRate: 0,
            monthlyInstallment: 0,
            totalInterest: 0,
            effectiveInterestRate: 0,
            effectiveMonthlyInstallment: 0,
            effectiveTotalInterest: 0,
            transactionSettlementAmount: 10000,
            transactionAmount: 10000,
            loanAmount: 10000,
            totalDiscountAmount: 0,
            flexmoneyDiscountAmount: 0,
            creditSchemeVariantId: 1001319,
            isSubventionEnabled: false,
            tenureType: 'DAYS',
            emiSchedule: {
              '1672905135729': 10000,
            },
          },
        ],
        emiDates: [1672905135729],
        emiNotes: [],
        lenderTncUrl: 'https://www.onlinesbi.com/sbijava/Terms_of_Use.html',
        flexmoneyNodalGrievanceOfficerDetails: {
          Name: 'Mr. Arun Ganapathy',
          Designation: 'Nodal Officer',
          Address:
            '405, B Wing, Rustomjee Central Park, Andheri - Kurla Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093',
          Contact: '8928385562',
          'Email Id': 'nodal.officer@flexmoney.in',
        },
        kfsEnabled: false,
      },
    ],

    callBackData: {},
  },
};



// WEBPACK FOOTER //
// ./constants/cwData.js